import React, { Fragment, useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import SettingIcon from "../../icons/settingIcon";
import styles from "./style.module.css";

const SubMenu = ({ item, isScrolling }) => {
    const location = useLocation();
    const isInclude = location.pathname.includes(item.link);
    const [isFirstChildActive, setIsFirstChildActive] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [btnActive, setBtnActive] = useState(false);

    const handleToggle = () => {
        setIsOpen(!isOpen);
    }

    useEffect(() => {
        setIsOpen(false);
    }, [isScrolling]);

    useEffect(() => {
        if (item?.children && isInclude) {
            if (item.link === location.pathname.substring(1)) {
                setIsFirstChildActive(true);
            } else {
                setIsFirstChildActive(false);
            }
        }
    }, [item, isInclude, location]);

    useEffect(() => {
        const path = location.pathname.substring(1);
        const hasMatchingChild = item?.children?.some(child => child.link === path) || path === item.link;
        setBtnActive(hasMatchingChild);
    }, [item, location]);

    return (
        <Fragment>
            <button type="button" onClick={handleToggle} className={btnActive ? 'active' : ''}>
                <SettingIcon />
            </button>
            {isOpen && (
                <div className={styles.mobile_menu_sub}>
                    {item.children.map((child, index) => (
                        <NavLink key={index} to={`/${child.link}`} className={({ isActive }) =>
                            isActive || (index === 0 && isFirstChildActive)
                                ? `active`
                                : ""
                        }>{child.title}</NavLink>
                    ))}
                </div>
            )}
        </Fragment>
    );
};

export default SubMenu;
